module.exports = __webpack_public_path__ + "static/media/12454851961582823590.c9ae4d3f.svg";